import React from "react";

const Support = (props) => {
  return (
    <section className="wpo-support-section">
      <div className="container">
        <div className="wpo-support-wrapper">
          <div className="wpo-support-text w-100">
            <h2>SOLUÇÕES EM RECURSOS HUMANOS</h2>
          </div>
          <div className="d-flex flex-column gap-3">
            <div className="w-100 d-flex align-items-center gap-4">
              <i
                class="fa fa-arrow-right"
                style={{ color: "white" }}
                aria-hidden="true"
              ></i>
              <p className="text-white mb-0 fs-5">
                Encontramos os profissionais ideais para sua empresa, alinhados
                à cultura organizacional e às necessidades do mercado.
              </p>
            </div>
            <div className="w-100 d-flex align-items-center gap-4">
              <i
                class="fa fa-arrow-right"
                style={{ color: "white" }}
                aria-hidden="true"
              ></i>
              <p className="text-white mb-0 fs-5">
                Assuma o controle da sua operação com eficiência, deixando as
                tarefas de RH conosco.
              </p>
            </div>
            <div className="w-100 d-flex align-items-center gap-4">
              <i
                class="fa fa-arrow-right"
                style={{ color: "white" }}
                aria-hidden="true"
              ></i>
              <p className="text-white mb-0 fs-5">
                Desenvolva práticas de gestão de pessoas que tragam resultados
                duradouros para o seu negócio.
              </p>
            </div>
            <div className="w-100 d-flex align-items-center gap-4">
              <i
                class="fa fa-arrow-right"
                style={{ color: "white" }}
                aria-hidden="true"
              ></i>
              <p className="text-white mb-0 fs-5">
                Oferecemos soluções completas e seguras para o processamento de
                salários, encargos e benefícios.
              </p>
            </div>
            <div className="w-100 d-flex align-items-center gap-4">
              <i
                class="fa fa-arrow-right"
                style={{ color: "white" }}
                aria-hidden="true"
              ></i>
              <p className="text-white mb-0 fs-5">
                Aperfeiçoe o desempenho de sua equipe com treinamentos
                especializados em diversas áreas de gestão de pessoas.
              </p>
            </div>
            <div className="cta-wrapper-solutions">
              <h3 className="text-white mb-0 w-75">
                Entre em contato agora e descubra como podemos ajudar sua
                empresa a alcançar o máximo de seu potencial com soluções
                estratégicas e personalizadas em Recursos Humanos.
              </h3>
              <div className="wpo-support-btn ">
                <a className="justify-content-center d-flex" href="https://wa.me/5511988799979?text=Ol%C3%A1">
                  Fale conosco
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Support;
